<template>
  <div>
    <!-- LANGUAGE AND REGION -->
    <section>
      <div
        class="account-title font-weight-bold color_grey_dark text-uppercase"
      >
        Language & Region
      </div>

      <div class="account-sub-text color_ash">English Language</div>
      <div class="account-sub-text color_ash d-flex">
        <div class="mr-5">{{ schoolTimezone }}</div>
        <div
          class="btn-link font-weight-bold text-uppercase link-no-underline"
          @click="toggleTimezoneModal"
        >
          Update Timezone
        </div>
      </div>
    </section>

    <!-- PROFILE URL -->
    <section>
      <div
        class="account-title font-weight-bold color_grey_dark text-uppercase"
      >
        PROFILE URL
      </div>

      <div class="account-sub-text color_ash">
        You can set a unique URL so people can easily fid more information about
        your school
      </div>

      <div class="input-group profile-url-input position-relative">
        <!-- URL DOMAIN -->
        <span class="url-domain" v-if="show_domain">{{ domain_url }}</span>
        <!-- INPUT -->
        <input
          type="text"
          v-model="profile_url"
          class="form-control"
          placeholder="christland_intl_school"
          ref="profileurlinput"
        />

        <!-- COPY LINK -->
        <span class="input-group-addon cover color_white_bg rounded-25 pointer">
          <span
            class="border_grey_dark font-10 text flex-center"
            @click="copyProfileURL"
            >COPY</span
          >
        </span>
      </div>
    </section>

    <!-- DEACTIVATE -->
    <section class="border-0" ref="deactivateSection">
      <div
        class="account-title font-weight-bold color_grey_dark text-uppercase"
      >
        DEACTIVATE YOUR SCHOOL
      </div>

      <!-- DEACTIVATE INFO TEXT -->
      <div class="account-sub-text color_ash multple-line">
        This will remove all information about you, your classes, and your
        students. Once deleted, you have 60 days to retrieve your account until
        it is deleted permanently.
      </div>

      <!-- DEACTIVATE BUTTON -->
      <div class="account-sub-text color_ash d-flex">
        <button class="btn btn-md btn-tonic-outline" @click="toggleDeleteModal">
          DEACTIVATE
        </button>
      </div>
    </section>

    <!-- ACCOUNT MODAL -->
    <DeleteSchoolAccount
      account_type="school"
      v-if="delete_modal"
      @closeTriggered="toggleDeleteModal"
    ></DeleteSchoolAccount>

    <TimezoneModal
      v-if="timezone_modal"
      @remountTimezone="fetchSchoolTimezone"
      @closeTriggered="toggleTimezoneModal"
      @showAlertCard="popUpAlert($event)"
    ></TimezoneModal>

    <ResponseDialog
      v-if="response_dialog"
      :alert_msg="alert_card_msg"
      :alert_type="alert_card_type"
      @closeAlert="toggleResponseDialog"
    ></ResponseDialog>
    <!-- ACCOUNT MODAL -->
  </div>
</template>

<script>
import { mapActions } from "vuex";

export default {
  name: "AccountPreference",

  components: {
    DeleteSchoolAccount: () =>
      import(
        /* webpackChunkName: "DeleteSchoolAccount" */ "@/components/modalComps/settingsModals/DeleteSchoolAccount"
      ),
    TimezoneModal: () =>
      import(
        /* webpackChunkName: "TimezoneModal" */ "@/components/modalComps/settingsModals/TimezoneModal"
      ),
    ResponseDialog: () =>
      import(
        /* webpackChunkName: "ResponseDialog" */ "@/components/globalComps/ResponseDialog"
      ),
  },

  computed: {
    schoolTimezone() {
      if (this.timezone !== null) return this.timezone;
      else return "No timezone";
    },
  },

  data() {
    return {
      domain_url: "www.gradely.ng/",
      profile_url: "",
      show_domain: true,
      delete_modal: false,
      timezone_modal: false,
      timezone: null,

      alert_card_msg: "",
      alert_card_type: "",
      response_dialog: false,
    };
  },

  mounted() {
    this.fetchActiveUser();
    this.fetchSchoolTimezone();
  },

  methods: {
    ...mapActions(["getActiveUserProfile", "getSchoolProfile"]),

    toggleResponseDialog() {
      this.response_dialog = !this.response_dialog;
    },

    popUpAlert($event) {
      this.alert_card_msg = $event.msg;
      this.alert_card_type = $event.type;
      this.toggleResponseDialog();
    },

    toggleDeleteModal() {
      this.delete_modal = !this.delete_modal;
    },

    toggleTimezoneModal() {
      this.timezone_modal = !this.timezone_modal;
    },

    copyProfileURL() {
      let url_input = this.$refs.profileurlinput;
      url_input.value = `${this.domain_url}${this.profile_url}`;
      url_input.focus();
      url_input.select();
      url_input.setSelectionRange(0, 99999); /*For mobile devices*/

      document.execCommand("copy");

      this.alert_card_msg = "Profile URL copied successfully";
      this.alert_card_type = "success";
      this.toggleResponseDialog();
    },

    fetchActiveUser() {
      this.getActiveUserProfile()
        .then((response) => {
          if (response.code === 200) {
            // ENABLE LATER
            // this.profile_url = response.data.school_slug;
            if (response.data.school_owner !== 1)
              this.$refs.deactivateSection.classList.add("d-none");
          }
        })
        .catch((err) => console.log(err));
    },

    fetchSchoolTimezone() {
      this.getSchoolProfile()
        .then((response) => {
          if (response.code === 200) this.timezone = response.data.timezone;
        })
        .catch((err) => console.log(err));
    },
  },
};
</script>

<style lang="scss">
section {
  padding: 0px 2px 30px;
  border-bottom: 1px solid $border_grey;

  .account-title {
    margin-top: 30px;
    font-size: 16px;
    line-height: 22px;
    margin-bottom: 20px;

    @include breakpoint_max(sm) {
      font-size: 13.5px;
    }
    @include breakpoint_max(xs) {
      font-size: 12px;
    }
  }

  .account-sub-text {
    font-size: 14px;
    line-height: 19px;
    margin-bottom: 15px;

    @include breakpoint_max(sm) {
      font-size: 13px;
    }
    @include breakpoint_max(xs) {
      font-size: 12px;
    }
  }

  .multple-line {
    line-height: 165%;
  }

  .profile-url-input {
    .cover {
      width: 61px;
      height: 30px;
      margin-right: 10px;
      transition: all 0.4s ease-in-out;
      &:hover {
        background: $color_ash !important;
      }
    }

    .url-domain {
      position: absolute;
      font-size: 14px;
      left: 10px;
      top: 50%;
      transform: translateY(-50%);
      color: $color_grey_dark;
      z-index: 9;

      @include breakpoint_max(sm) {
        font-size: 12px;
        margin-top: -1px;
      }
    }

    input {
      padding-left: 122px;
      position: relative;
      top: -1px;

      @include breakpoint_max(sm) {
        padding-left: 168px;
      }

      @include breakpoint_max(xs) {
        padding-left: 105px;
      }
    }

    .input-group-addon {
      transition: all 0.4s ease-in-out;

      &:hover {
        background: $brand_inverse !important;
        span {
          color: $color_text !important;
        }
      }
    }
  }
}
</style>
